const Customers = () => import(/* webpackChunkName: "v-admin" */ '@/components/page/admin/customers/Customers')
const Fleets = () => import(/* webpackChunkName: "v-admin" */ '@/components/page/admin/fleets/Fleets')
const Gateways = () => import(/* webpackChunkName: "v-admin" */ '@/components/page/admin/gateways/Gateways')
const Clusters = () => import(/* webpackChunkName: "v-admin" */ '@/components/page/admin/clusters/Clusters')
const PushConfigurations = () => import(/* webpackChunkName: "v-admin" */ '@/components/page/admin/clusters/PushConfigurations')
const MulticastGroups = () => import(/* webpackChunkName: "v-admin" */ '@/components/page/admin/multicastGroups/MulticastGroups')
const EndDevices = () => import(/* webpackChunkName: "v-admin" */ '@/components/page/admin/endDevices/EndDevices')
const Users = () => import(/* webpackChunkName: "v-admin" */ '@/components/page/admin/users/Users')
const Softwares = () => import(/* webpackChunkName: "v-admin" */ '@/components/page/admin/softwares/Softwares')

const routes = [
  {
    path: 'administration/customers',
    component: Customers,
    meta: {
      roles: ['SUPER_ADMIN'],
      hasFloatingButton: true
    }
  }, {
    path: 'administration/fleets',
    component: Fleets,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      hasFloatingButton: true
    }
  }, {
    path: 'administration/gateways',
    component: Gateways,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      hasFloatingButton: true
    }
  }, {
    path: 'administration/clusters',
    component: Clusters,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      hasFloatingButton: true
    }
  }, {
    path: 'administration/push-configurations',
    component: PushConfigurations,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      hasFloatingButton: true
    }
  }, {
    path: 'administration/multicast-groups',
    component: MulticastGroups,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      hasFloatingButton: true
    }
  }, {
    path: 'administration/end-devices',
    component: EndDevices,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      hasFloatingButton: true
    }
  }, {
    path: 'administration/users',
    component: Users,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      hasFloatingButton: true
    }
  }, {
    path: 'administration/softwares',
    component: Softwares,
    meta: {
      roles: ['SUPER_ADMIN'],
      hasFloatingButton: true
    }
  }
]

export default routes
